'use client';

import {PortableText} from '@/modules/foundation/sanity/portable-text';

import {
	CompaniesListLinks,
	companiesListLinksDescriptionPortableTextOverrides,
} from '../../components/companies-list-links';

import type {CompaniesListLinksFragment} from './query';

type Props = {
	data: CompaniesListLinksFragment;
	fullWidth?: boolean;
	anchorHeadings?: boolean;
	insideToc?: boolean;
};

export const CompaniesListLinksContainer = ({
	data,
	fullWidth,
	anchorHeadings,
	insideToc,
}: Props) => {
	const {heading, contentBlockOptions, description, filter} = data;

	return (
		<CompaniesListLinks
			heading={heading}
			anchorHeadings={anchorHeadings}
			description={
				description && description.length > 0 ? (
					<PortableText
						value={description}
						overrideClassNames={
							companiesListLinksDescriptionPortableTextOverrides
						}
					/>
				) : null
			}
			filter={filter}
			options={{
				fullWidth,
				...contentBlockOptions,
			}}
			insideToc={insideToc}
		/>
	);
};
